/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash/get';
import Pagination from './Pagination';
import GalleryPagination from './GalleryPagination';
import { disableFilterAnalytics, getProductsPerPage, getURLParameterBykey } from '../../utils';
import { selectEnableDesktopViewForTabletLandscapeOrientation } from '../../selectors/FeatureFlag';

export class LoadPagination extends Component {
    static defaultProps = {
        containerTheme: null,
        deviceType: {},
        onPageChange: null,
    };

    static propTypes = {
        enableDesktopViewForTablet: PropTypes.bool.isRequired,
        enableNewPagination: PropTypes.bool.isRequired,
        enableMktBasedTotalPage: PropTypes.bool.isRequired,
        featureFlags: PropTypes.object.isRequired,
        marketingTilesInitialCount: PropTypes.number.isRequired,
        pagination: PropTypes.object.isRequired,
        productsPerPage: PropTypes.number.isRequired,
        containerTheme: PropTypes.string,
        deviceType: PropTypes.object,
        onPageChange: PropTypes.func,
    };

    constructor() {
        super();
        this.onPageChange = this.onPageChange.bind(this);
        this.handleOrientationChange = this.handleOrientationChange.bind(this);
    }

    componentDidMount() {
        const { enableDesktopViewForTablet } = this.props;
        if (enableDesktopViewForTablet) {
            window.addEventListener('orientationchange', this.handleOrientationChange);
        }
    }

    componentWillUnmount() {
        const { enableDesktopViewForTablet } = this.props;
        if (enableDesktopViewForTablet) {
            window.removeEventListener('orientationchange', this.handleOrientationChange);
        }
    }

    // eslint-disable-next-line class-methods-use-this
    handleOrientationChange() {
        /* YODATOF-134
         * we need to blur select drodpown in iPad since it keeps the dropdown open on orientation change
         * and since it is a select dropdown; even when we hide the parent which triggered the dropdown,
         * the dropdown is still shown.
         */
        const paginationSelect = document.querySelectorAll(
            "select[data-automation-id='paginationDropdown']"
        );
        paginationSelect[0] && paginationSelect[0].blur();
    }

    onPageChange(pageNumber) {
        const { onPageChange } = this.props;
        disableFilterAnalytics();
        let mktTiles;

        if (
            !this.props.featureFlags.disableOrphanProducts &&
            pageNumber > 1 &&
            this.props.marketingTilesInitialCount > 0
        ) {
            mktTiles = this.props.marketingTilesInitialCount;
        }
        onPageChange(
            pageNumber > 1 ? pageNumber : null,
            mktTiles,
            this.props.marketingTilesInitialCount > 0
        );
    }

    getMarketingTilesInitialCount = () => {
        const { marketingTilesInitialCount, featureFlags } = this.props;
        let mkTiles;
        if (!featureFlags.disableOrphanProducts) {
            mkTiles =
                marketingTilesInitialCount >= 0
                    ? marketingTilesInitialCount
                    : getURLParameterBykey('mktTiles');
        }
        return mkTiles || 0;
    };

    /* istanbul ignore next */
    getTotalPaginationPage = (pagination) => {
        const marketingTiles = this.getMarketingTilesInitialCount();
        if (pagination && marketingTiles > 0) {
            const {
                productsPerPage,
                totalPages,
                selectedPageNumber,
                totalProductsCount,
            } = pagination;
            if (totalPages < 25 && selectedPageNumber === 1) {
                const paginationTotalPages = Math.ceil(
                    (totalProductsCount + marketingTiles) / productsPerPage
                );
                const modifyPagination = { ...pagination };
                modifyPagination.totalPages = paginationTotalPages;

                return modifyPagination;
            }

            return pagination;
        }
        return pagination;
    };

    /* istanbul ignore next */
    fetchPaginationObj = (pagination) => {
        const { enableMktBasedTotalPage } = this.props;
        const paginationObj = enableMktBasedTotalPage
            ? this.getTotalPaginationPage(pagination)
            : pagination;
        return paginationObj;
    };

    render() {
        const {
            deviceType,
            productsPerPage,
            pagination,
            containerTheme,
            enableNewPagination,
        } = this.props;

        if (_get(pagination, 'totalProductsCount') > 0 && !__SERVER__) {
            if (enableNewPagination) {
                return (
                    <GalleryPagination
                        {...this.fetchPaginationObj(pagination)}
                        {...containerTheme}
                        onPageChange={this.onPageChange}
                        marketingTilesInitialCount={this.getMarketingTilesInitialCount()}
                        deviceType={deviceType}
                        productsPerPage={productsPerPage}
                    />
                );
            }
            return (
                <Pagination
                    {...pagination}
                    {...containerTheme}
                    onPageChange={this.onPageChange}
                    marketingTilesInitialCount={this.getMarketingTilesInitialCount()}
                    deviceType={deviceType}
                    productsPerPage={productsPerPage}
                />
            );
        }
        return <div />;
    }
}

const mapStateToProps = (store) => ({
    pagination: store.pagination.pagination,
    deviceType: store.context.deviceType,
    featureFlags: store.context.featureFlags,
    marketingTilesInitialCount: store.irisContent.coreZone.marketingTilesInitialCount,
    productsPerPage: getProductsPerPage(store),
    enableDesktopViewForTablet: selectEnableDesktopViewForTabletLandscapeOrientation(store),
    enableNewPagination: _get(store, 'context.featureFlags.enableNewPagination', true),
    enableMktBasedTotalPage: _get(store, 'context.featureFlags.enableMktBasedTotalPage', true),
});

export default connect(mapStateToProps)(LoadPagination);
